import { deleteApi, getApi, postApi, putApi } from "../apis";

export const addArea = (data) => {
    return postApi('/api/area', data);
};

export const editArea = (data, id) => {
    return putApi('/api/area/' + id, data);
};

export const listAreas = () => {
    return getApi('/api/area');
};

export const deleteArea = (id) => {
    return deleteApi("/api/area/" + id);
};

export const getAreaById = (id) => {
    return getApi("/api/area/" + id);
};
